module.exports = __webpack_public_path__ + "img/lkw.fb18948a.png";